import React, { useCallback, useRef, useState } from 'react';
import { LoadPanel } from 'devextreme-react/load-panel';
import { postFile, getFile } from '../../utils/api';
import style from './pdfviewer.module.scss';
import { getLocale } from '../../utils/functions';

const PdfViewer = ({
  match,
  modalErrorOpen
}) => {
  const canvasRef = useRef();
  const [loader, setLoader] = useState(false);
  try {
    const [dataRest] = useState(JSON.parse(decodeURIComponent(escape(window.atob(
      match.params.data
    )))));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const onLoadIframe = useCallback(() => {
      if (
        canvasRef.current
        && canvasRef.current.contentWindow
        && canvasRef.current.contentDocument
      ) {
        let errorFlag = false;
        const viewer = canvasRef.current.contentWindow.PDFViewerApplication;
        // eslint-disable-next-line no-shadow
        const loader = async () => {
          if (dataRest.restMethod === 'getFile') {
            setLoader(true);
            try {
              const { data, headers } = await getFile(dataRest.url, {
                responseType: 'arraybuffer',
                headers: { 'Accept-Language': getLocale() }
              })
                .catch((error) => {
                  modalErrorOpen({
                    message: 'Ошибка при формировании отчета на сервере',
                    techInfo: error.message || '',
                    types: 'error',
                    title: 'Предупреждение'
                  });
                });
              viewer.open(data);
              if (
                headers
                && headers['content-disposition']
                && headers['content-disposition'].match(/filename=(.+).pdf/i)
              ) {
                const temp = headers['content-disposition'].match(/filename=(.+).pdf/i);
                viewer.url = `${temp[1]}.pdf`;
              }
            } catch (e) {
              modalErrorOpen({
                message: 'Ошибка при формировании отчета на сервере',
                techInfo: e.message || '',
                types: 'error',
                title: 'Предупреждение'
              });
            }
            setLoader(false);
          }
          if (dataRest.restMethod === 'postFile') {
            setLoader(true);
            try {
              const responce = await postFile(dataRest.url, dataRest.args, {
                responseType: 'arraybuffer',
                headers: { 'Accept-Language': getLocale() }
              })
                .catch((error) => {
                  try {
                    const utf8decoder = new TextDecoder();
                    const temp = JSON.parse(utf8decoder.decode(error.response.data));
                    modalErrorOpen({
                      message: temp.message || 'Ошибка при формировании отчета на сервере',
                      techInfo: temp.techInfo || '',
                      types: 'error',
                      title: 'Предупреждение'
                    });
                    errorFlag = true;
                  } catch (e) {
                    modalErrorOpen({
                      message: 'Ошибка при формировании отчета на сервере',
                      techInfo: '',
                      types: 'error',
                      title: 'Предупреждение'
                    });
                    errorFlag = true;
                  }
                });
              if (responce.data) {
                viewer.open(responce.data);
              }
              if (
                responce.headers
                && responce.headers['content-disposition']
                && responce.headers['content-disposition'].match(/filename=(.+).pdf/i)
              ) {
                const temp = responce.headers['content-disposition'].match(/filename=(.+).pdf/i);
                viewer.url = `${temp[1]}.pdf`;
              }
            } catch (e) {
              if (!errorFlag) {
                modalErrorOpen({
                  message: 'Ошибка при формировании отчета на сервере',
                  techInfo: e.message || '',
                  types: 'error',
                  title: 'Предупреждение'
                });
              }
            }
            // console.debug(headers['content-disposition']);
            setLoader(false);
            // console.dir(viewer);
          }
        };
        loader();
      }
    }, [dataRest, modalErrorOpen]);
    return (
      <>
        <LoadPanel shadingColor={'rgba(0,0,0,0.8)'}
                   position={{ of: '#root' }}
                   showIndicator
                   shading
                   showPane
                   closeOnOutsideClick={false}
                   visible={loader}
        />
        <iframe
          ref={canvasRef}
          className={style.pdfViewerFrame}
          src={'/pdfview/web/viewer.html?file='}
          title={'PDF Viewer'}
          onLoad={onLoadIframe}
        />
      </>
    );
  } catch (e) {
    modalErrorOpen({
      message: 'Ошибка при формировании отчета',
      techInfo: e.techInfo || '',
      types: 'error',
      title: 'Предупреждение'
    });
    return (
      <iframe
        className={style.pdfViewerFrame}
        src={'/pdfview/web/viewer.html?file='}
        title={'PDF Viewer'}
      />
    );
  }
};

export default PdfViewer;
